export const EMAIL = "anonymous@nimber.pt";
